var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 469.333 469.333",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 234.667,
    cy: 53.333,
    r: 53.333,
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.521 213.333h146.292c12.604 0 22.854-11.063 22.854-24.667v-6.833c0-17.823-8.823-34.104-23.042-42.49-17.031-10.042-43.51-22.01-72.958-22.01s-55.927 11.969-72.958 22.01c-14.219 8.385-23.042 24.667-23.042 42.49v6.833c0 13.605 10.25 24.667 22.854 24.667z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 309.333,
    r: 53.333,
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.958 395.344c-17.031-10.042-43.51-22.01-72.958-22.01s-55.927 11.969-72.958 22.01C8.823 403.729 0 420.01 0 437.833v6.833c0 13.604 10.25 24.667 22.854 24.667h146.292c12.604 0 22.854-11.063 22.854-24.667v-6.833c0-17.823-8.823-34.104-23.042-42.489z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.333,
    cy: 309.333,
    r: 53.333,
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.292 395.344c-17.031-10.042-43.51-22.01-72.958-22.01s-55.927 11.969-72.958 22.01c-14.219 8.385-23.042 24.667-23.042 42.49v6.833c0 13.604 10.25 24.667 22.854 24.667H446.48c12.604 0 22.854-11.063 22.854-24.667v-6.833c-.001-17.824-8.824-34.105-23.042-42.49zM287.99 362.667c3.135 0 6.229-1.375 8.344-4 3.677-4.604 2.927-11.313-1.667-15l-49.333-39.466v-58.867c0-5.896-4.771-10.667-10.667-10.667S224 239.437 224 245.333v58.875l-49.333 39.458c-4.594 3.688-5.344 10.396-1.667 15 2.115 2.625 5.208 4 8.344 4 2.333 0 4.688-.76 6.656-2.333L234.667 323l46.666 37.333a10.631 10.631 0 0 0 6.657 2.334z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefer);
export default __webpack_public_path__ + "static/media/refer.2f999b3c180bd856e3703bb549581f0c.svg";
export { ForwardRef as ReactComponent };